import classNames from "../../classNames";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./NavBar2.css";

const menus = [
  { name: "Home", route: "/" },
  { name: "About Us", route: "/about" },
  { name: "Solutions", route: "/solutions" },
  { name: "Contact", route: "/contact" },
];

function NavBar2({ className }) {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    const timeout = setTimeout(() => setVisible(true), 400);
    return () => clearTimeout(timeout);
  }, []);

  const classes = classNames(
    className,
    "navbar sticky-top navbar-expand-lg py-3 position-absolute top-0 start-0 w-100",
    {
      "bg-white": visible,
      "bg-transparent": !visible,
    }
  );

  return (
    <nav
      className={classes}
      style={{
        background: visible
          ? "linear-gradient(89.77deg, rgba(255, 255, 255, 0.7) 25.61%, rgba(57, 57, 57, 0.4) 46.77%, rgba(6, 6, 6, 0.5) 78.75%)"
          : "transparent",
        backdropFilter: visible ? "blur(5px)" : "none",
        opacity: visible ? 1 : 0,
        transition: "opacity 1s ease-in-out",
        zIndex: 10,
      }}
    >
      <div className="container d-flex justify-content-between align-items-center">
        <div className="logo-wrapper">
          <img
            src="/assets/tenth_Logo.png"
            alt="Tenth Corporation Logo"
            height="60"
          />
        </div>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainNavbar"
        >
          <span style={{ color: "white" }}>
            <i className="bi bi-list"></i>
          </span>
        </button>

        <div
          className="collapse navbar-collapse justify-content-end"
          id="mainNavbar"
        >
          <ul className="navbar-nav gap-3 align-items-center">
            {menus.map((menu) => (
              <li className="nav-item" key={menu.name}>
                <Link
                  to={menu.route}
                  onMouseEnter={() => setHovered(menu.name)}
                  onMouseLeave={() => setHovered(null)}
                  className="nav-link fw-medium text-white"
                  style={{
                    borderBottom:
                      hovered === menu.name || location.pathname === menu.route
                        ? "2px solid white"
                        : "2px solid transparent",
                    transition: "border-bottom 0.3s",
                    paddingBottom: "4px",
                  }}
                >
                  {menu.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default NavBar2;
